// Central configuration for API and Socket URLs
// Automatically detects environment to prevent Mixed Content errors in production

const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// In development, we point to localhost:3000
// In production, we use relative paths so requests go to https://colonny.xyz/api/...
// This requires the web server (Nginx/Apache) to proxy /api and /socket.io to the backend port 3000
export const API_URL = isDevelopment ? 'http://localhost:3000' : '';

// For Socket.IO, passing undefined/null makes it connect to the current host (window.location)
export const SOCKET_URL = isDevelopment ? 'http://localhost:3000' : undefined;

// CDN del bucket de storage. El contenido dinámico ya viene resuelto del backend (que decide
// CDN vs GCS según `CDN_BASE_URL`); esta constante es solo para los pocos assets estáticos
// hardcodeados en el frontend (iconos de dapps, GIFs de login, empty-states). Dev y localhost
// también apuntan al CDN de prod — es contenido público, y el CORS del bucket incluye
// dev.colonny.xyz / localhost:5173.
export const CDN_URL = 'https://cdn.colonny.xyz';
// Construye la URL de un asset estático del bucket. `p` es el path SIN barra inicial
// (ej. 'colonny_uploads/x.png', 'assets/monkey_lost.png').
export const assetUrl = (p) => `${CDN_URL}/${String(p).replace(/^\/+/, '')}`;

console.log(`[Config] Env: ${isDevelopment ? 'DEV' : 'PROD'}, API: ${API_URL}`);
